import React, { useState } from "react";
import { Avatar, Dropdown, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { ReactComponent as HeartIcon } from "../../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../../Icons/heartSelect.svg";
import { useSelector } from "react-redux";
import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfWhiteIcon.svg";
import { markUnmarkFavourite } from "../../../API/api";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from "../../ToolTip/TooltipComp";
import { useLocation } from "react-router-dom";
import { DeleteOutlineOutlined, EditOutlined, FavoriteBorderOutlined, LocalFireDepartment, PeopleAltOutlined } from "@mui/icons-material";

export default function QuestionBox({ question,fav=true }) {
  const searchState = useSelector((state) => state.search);
  const currentPath = useLocation()
  const [isFavorite, setFavorite] = useState(question.favourite);
  const onCLickFavorite = (key, flag) => {
    markUnmarkFavourite(key.origQuestionUuid).then((res) => {
      if (res === undefined) return;
      setFavorite(flag);
      question.filter(obj => {
        if (obj.origQuestionUuid === key.origQuestionUuid) {
          obj.favourite = flag;
        }
      })
    });
  };
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom:'5px'
    // paddingLeft: "7px",

  };
  const textStyles = {
    fontSize: "24px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const confidenceStyles1 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #F59B00",
    borderRadius: "6px",
    backgroundColor: "#F59B00",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const confidenceStyles2 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #00A3FF",
    borderRadius: "6px",
    backgroundColor: "#00A3FF",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };

  const items = [
    {
      key: '1',
      label: (
        <a>
          <EditOutlined fontSize="24" style={{margin:'3px'}} />
          Edit
        </a>
      ),
    },
    {
      type:'divider',
    },
    {
      key: '2',
      label: (
        <a>
          <DeleteOutlineOutlined fontSize="24" style={{margin:'3px'}} />
          Delete
        </a>
      ),
    },
    {
      type:'divider',
    },
    {
      key: '3',
      label: (
        <a>
          <FavoriteBorderOutlined fontSize="24" style={{margin:'3px',color: question.favourite && '#FF6A00'}} />
          Favorite
        </a>
      ),
    },
    {
      type:'divider',
    },
    {
      key: '4',
      label: (
        <a>
          <PeopleAltOutlined fontSize="24" style={{margin:'3px'}} />
          Add to Watchlist
        </a>
      ),
    },
    {
      type:'divider',
    },
  ]
  const DropdownComponent = ({question}) => {
    console.log(question,'check question')
    return (
      <>
        <Dropdown menu={{ items }}>
          <img src={require('../../../Images/dots-vertical.png')} style={{ cursor: 'pointer' }} />
        </Dropdown>
      </>
    )
  }
  // console.log("fav",question)

  return (
    <>
      <div style={infoContainer}>
        <div style={dateInfoStyles}>
          <div style={textStyles}>
            {question.question}
          </div>
          <div style={infoContainer}>
          {question.seekerAttachments && question.seekerAttachments.length > 0 && (
              <Popover title={renderAttachemnt(question.seekerAttachments)}>
                {" "}
                <Button2 onClickFunc={onCLickFavorite}>
                  <DownloadIcon />
                </Button2>
              </Popover>)}
            {question.docType === "expertqa" && fav&&
              (isFavorite ? (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                  <HeartSelectedIcon
                    onClick={() => onCLickFavorite(question, false)}
                  />
                </div>
              ) : (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                  {/* <HeartIcon onClick={() => onCLickFavorite(question, true)} /> */}
                </div>
              ))}
            {question.isShowUpdateRequestWarning && <div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{ fontSize: '22px', color: '#F59B00', marginRight: '5px', cursor: 'pointer' }}></i></span></TooltipComp>
            </div>}
            {!currentPath.pathname.includes('/open') && <div
              style={
                question.confidence ? confidenceStyles2 : confidenceStyles1
              }
            >
              {question.docType === "expertqa" ? (
                "Q&A"
              ) : (
                <>
                  <PdfWhiteIcon style={{ marginBottom: "4px" }} />
                </>
              )}
            </div>}
          </div>
        </div>
      </div>
      {/* <span style={{color:'#5C667B',fontSize:'12px',fontWeight:400}}>Last Reviewed{" "}{momentit(question.postedTimestamp)}</span> */}
    </>
  );
}
